const authFlowPrefixes = ['/auth/sign-in'];

const isSafeReturnUrl = (url: string): boolean => {
  if (!url.startsWith('/') || url.startsWith('//') || url.startsWith('/\\')) {
    return false;
  }
  return !authFlowPrefixes.some(
    (prefix) =>
      url === prefix ||
      url.startsWith(`${prefix}?`) ||
      url.startsWith(`${prefix}/`),
  );
};

export default isSafeReturnUrl;
